/**
 * dmBadge.ts — FEAT DM-BADGE (Set 2026)
 *
 * Helper PURO per il badge non-letto dei messaggi diretti.
 * Il badge (numerino sul menu Chat) si incrementa SOLO per i messaggi
 * inviati da ALTRI utenti: il mittente con più device riceve l'evento
 * WebSocket solo per sincronizzare la vista, mai per auto-incrementare
 * le proprie notifiche non lette.
 */
import type { WsIncomingMessage } from "@/hooks/infrastructure/useWebSocket";

export function shouldIncrementDmUnread(
  msg: WsIncomingMessage,
  currentUserId?: string | null,
): boolean {
  if (msg.type !== "dm_message") return false;
  if (!currentUserId) return false;
  return msg.message.sender_id !== currentUserId;
}
